import React from 'react';
import {useRouteMatch} from 'react-router-dom';

import {ARIA_PATH} from '../../routes/aria/ariaPaths';
import {WBAgent} from './WBAgent';

/**
 * Keeps the drawer runtime off the full-page ARIA route, where AriaPage owns
 * the runtime instead.
 */
export const WBAgentNav = () => {
  const isAriaPage = useRouteMatch({path: ARIA_PATH, exact: true}) != null;
  return isAriaPage ? null : <WBAgent />;
};
